<template>
    <div class="people row">

        <!-- Inspector  -->
        <div v-if="hasInspectors" class="col-lg-4">
            <div class="card">
                <div class="card-body">
                    <div class="user inspector" :class="{ 'is-selected' : currentIndex == initialIndex}">
                        <div class="image">
                            <img v-if="selectedInspector" :src="selectedInspector.avatar" :alt="selectedInspector.name">
                            <img v-else src="/images/avatar.png">
                        </div>
                        <div class="details">
                            <div v-if="selectedInspector">
                                <h4 class="text-primary" v-text="selectedInspector.name"></h4>
                                <div class="legend mb-1">Inspector</div>
                                <div class="email" v-text="selectedInspector.email"></div>
                                <div class="phone" v-text="selectedInspector.profile.phone"></div>
                            </div>
                            <div v-else>
                                <p class="font-weight-bold text-danger">No Inspector Assigned Yet!</p>
                            </div>
                            <div v-if="(authorize('admin') || authorize('is_inspector')) && selectedInspector" class="count text-info">
                                <div v-if="isFieldInspection">
                                    <span class="font-weight-bold" v-text="selectedInspector.field_inspections_as_inspector_count"></span> Performed Field Inspections
                                </div>
                                <div v-else>
                                    <span class="font-weight-bold" v-text="selectedInspector.field_audits_as_inspector_count"></span> Performed Field Audits
                                </div>
                            </div>
                            <div v-if="canUpdateInspector" class="btn-group btn-change-inspector" role="group" aria-label="Select Inspector">

                                <!-- Arrow Left -->
                                <button class="btn btn-default btn-sm" @click="previous()" >
                                    <i class="fa fa-arrow-left"></i>
                                </button>

                                <!-- Change Inspector Save Button -->
                                <button class="btn btn-success btn-sm" :disabled="!canChangeInspector || form.isSubmitted" @click="save()">
                                    Save
                                </button>

                                <!-- Arrow Right -->
                                <button class="btn btn-default btn-sm" @click="next()">
                                    <i class="fa fa-arrow-right"></i>
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- Employer -->
        <div v-if="auditableItem.employer" class="col-lg-4">
            <div class="card">
                <div class="card-body">
                    <div class="user employer">
                        <div class="image">
                            <img :src="auditableItem.employer.avatar" :alt="auditableItem.employer.name">
                        </div>
                        <div class="details">
                            <h4 class="text-primary" v-text="auditableItem.employer.name"></h4>
                            <div class="legend mb-1">
                                <span v-text="auditableItem.employer.employer_number"></span>
                            </div>
                            <div class="email" v-text="auditableItem.employer.email"></div>
                            <div class="phone" v-text="auditableItem.employer.profile.phone"></div>
                            <div class="count text-info" v-if="hasInspectors">
                                <div v-if="isFieldInspection">
                                    <span class="font-weight-bold" v-text="auditableItem.employer.field_inspections_as_employer.length"></span> Assigned Field Inspections
                                </div>
                                <div v-else>
                                    <span class="font-weight-bold" v-text="auditableItem.employer.field_audits_as_employer.length"></span> Assigned Field Audits
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Technician -->
        <div class="col-lg-4">
            <div class="card">
                <div class="card-body">
                    <div class="user technician">
                        <div class="image">
                            <img :src="auditableItem.technician.avatar" :alt="auditableItem.technician.name">
                        </div>
                        <div class="details">
                            <h4 class="text-primary" v-text="auditableItem.technician.name"></h4>
                            <div class="legend mb-1" v-text="auditableItem.technician.att_number"></div>
                            <div class="email" v-text="auditableItem.technician.email"></div>
                            <div class="phone" v-text="auditableItem.technician.profile.phone"></div>
                            <div class="count text-info" v-if="hasInspectors">
                                <div v-if="isFieldInspection">
                                    <span class="font-weight-bold" v-text="auditableItem.technician.field_inspections_as_technician.length"></span> Field Inspections
                                </div>
                                <div v-else>
                                    <span class="font-weight-bold" v-text="auditableItem.technician.field_audits_as_technician.length"></span> Field Audits
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        props:{
            value: {
                type: Object,
                required: true,
            },
            inspectors:{
                type: Array,
                required: false,
                default: () => []
            }
        },

        data() {
            return {
                initialIndex: null,
                currentIndex: null,
                auditableItem: this.value,
                inspector: this.value.inspector,
                form: new Form({
                    inspector_id: this.value.inspector ? this.value.inspector.id : null,
                }, false)
            }
        },

        created() {
            if (this.hasInspectors) {
                let index = null
                if(this.inspector){
                    index = _.findIndex(this.inspectors, {id: this.inspector.id})
                }
                this.initialIndex = this.currentIndex = index
            }
        },

        methods: {

            save(){
                this.form.inspector_id = this.selectedInspector.id;
                this.form.patch(`/field-audits/${this.auditableItem.number}`).then(response => {
                    this.$emit('input', response)
                });
            },

            next() {
                if (this.currentIndex == (this.inspectors.length - 1)) {
                    this.currentIndex = 0;
                    return;
                }
                this.currentIndex++;
            },

            previous() {
                if (this.currentIndex == 0) {
                    this.currentIndex = (this.inspectors.length - 1);
                    return;
                }
                this.currentIndex--;
            }
        },

        watch: {
            value(val) {
                if(this.hasInspectors){
                    let index = null
                    if(val.inspector){
                        index = _.findIndex(this.inspectors, {id: val.inspector.id})
                    }
                    // this.initialIndex = this.currentIndex = index

                    this.initialIndex = index
                }
            }
        },

        computed: {
            selectedInspector() {
                if (!this.hasInspectors) return null;
                if (this.currentIndex < 0) return null;
                if (this.currentIndex == null) return null;
                return this.inspectors[this.currentIndex];
            },

            canChangeInspector() {
                if (!this.hasInspectors) return null;
                return this.initialIndex != this.currentIndex;
            },

            hasInspectors() {
                return !!this.inspectors.length;
            },

            samePerson() {
                if (this.auditableItem.employer == null) return false;
                return this.auditableItem.employer.id == this.auditableItem.technician.id;
            },

            canUpdateInspector() {
                return this.hasInspectors && this.auditableItem.status === null && (this.authorize('admin') || this.authorize('is_inspector'));
            },

            isFieldInspection() {
                return window.location.pathname.indexOf("field-inspections") > -1;
            }
        },

    }
</script>
